module.exports = __webpack_public_path__ + "static/2-50e0c84f5a086469d86333c3633bc181.jpg";